import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import {
	ButtonIconComponent,
	EmptyStateComponent,
	IconComponent,
	InfoGroupComponent,
	TagComponent,
	TileComponent,
} from '@tecalisdev/infinity';
import { RolePermissionsService } from '../../../core/services/role-permissions.service';
import { ExpirationDatePipe } from '../../../core/pipes/expiration-date.pipe';
import { SafeDatePipe } from '../../../core/pipes/safe-date.pipe';
import { MasterService } from '../../services/master.service';
import { DeveloperCurlButtonComponent } from '../developer-curl-button/developer-curl-button.component';

/**
 * NIF-1047: tile Identidad compartido (identities-detail + process-detail).
 * Datos normalizados; extras (block/unlock, link, address) vía proyección.
 */
@Component({
	selector: 'app-identity-info-tile',
	imports: [
		TranslatePipe,
		SafeDatePipe,
		ExpirationDatePipe,
		TileComponent,
		InfoGroupComponent,
		IconComponent,
		TagComponent,
		EmptyStateComponent,
		ButtonIconComponent,
		DeveloperCurlButtonComponent,
	],
	templateUrl: './identity-info-tile.component.html',
	styleUrl: './identity-info-tile.component.scss',
})
export class IdentityInfoTileComponent {
	@Input() hasData = true;
	@Input() fullName = '';
	@Input() identifier: string | null | undefined;
	@Input() documentType: string | null | undefined;
	@Input() expirationDate: string | null | undefined;
	@Input() birthDate: string | null | undefined;
	/** Edad en años; null/undefined → no muestra tag. */
	@Input() ageYears: number | null | undefined;
	@Input() gender: string | null | undefined;
	@Input() nationality: string | null | undefined;
	@Input() showEdit = false;
	@Input() curlPath = '';
	@Input() curlTitleKey = 'PROCESSES.CURL_MODAL.TITLE_IDENTITY';

	@Output() readonly editIdentity = new EventEmitter<void>();

	public readonly masterService = inject(MasterService);
	public readonly rolePermissions = inject(RolePermissionsService);

	public get canShowEdit(): boolean {
		return this.showEdit && this.rolePermissions.canEditPerson();
	}

	public onEditClick(): void {
		this.editIdentity.emit();
	}
}
